import * as React from "react";
import Box from "@mui/material/Box";

type props={
    title:string;
    content:string;
}

const Pdf = ({title,content}:props) => {
    return (
        <Box  sx={{ width: "100%" }}>
            <ul className="cmn_crd_wp gap_m ">
                <li >
                    <div className="in_row">
                        <figure>
                            <img src={`/static/images/pdf.png`} alt="png" />
                        </figure>
                        <div className="dsc">
                            <h4>{title||"Math Study Material"}</h4>
                            <p>Chapter 12 </p>
                            <p>Grade 12th</p>
                        </div>
                    </div>
                    <div 
                    // onClick={() => window.open(content, '_blank', 'noopener,noreferrer')}
                     className="btn_full"
                    >
                        <button className="btn primary">Download</button>
                    </div>
                </li>
            </ul>
        </Box>
    );
};

export default Pdf;
